export const breakpoints = {
  desktop: 1024,
  mobile: 0,
  tablet: 768,
} as const
